import React, {useState, useEffect} from 'react'

import "./BehavioralClusters.css"
import Sidebar from "../../shared/sidebar/Sidebar"
import Navbar from "../../shared/navbar/Navbar"
import DataTable from "../../shared/datatable/DataTable"
import axios from 'axios'
import BehaviourClusterEditor from './Editor'
import { format } from 'fecha';
import ErrorMessages from '../../shared/errormessages/ErrorMessages';

const BehavioralClusters = () => {
  const [editorState, setEditorState] = useState({open: false, data: null})
  const [pageState, setPageState] = useState({ loading: false})
  const [pageData, setPageData] = useState({
      status: "",
      data: [],
      total: 0
  })

  const [errors, setErrors] = useState("")

  useEffect(()=>{
    if(pageState.loading == false){
      axios.get('/behavioralclusters/getlist')
        .then(function (response) {
            if(response.data.status == "success"){
              setErrors("");
              setPageData(response.data);
              setPageState({loading: true});
            }
            else{
              setErrors(response.data.message);
            }
        })
        .catch(function (error) {
          setErrors(error.message);
        });
    }
  })

  const model = {
    columns: [
      {
        field: "SequenceNumber",
        headerName: "S.No.",
        width: 80,
      },
      {
        field: "Name",
        headerName: "Behaviour Cluster",
        width: 200,
        renderCell: (params) => {
          return (
            <div className="cellWithLink" onClick={()=> handleOnCellClick(params)}>
              {params.row.Name}
            </div>
          );
        },
      },
        {
          field: "Color",
          headerName: "Color",
          width: 100,
          renderCell: (params) => {
            const bgStyle = {
                backgroundColor: params.row.Color,
                color: '#fff',
                fontWeight: 'bold',
                borderRadius: "50%",
                width: "32px",
                height: "32px"
            };
            return (
                <span style={bgStyle}>&nbsp;</span>
            );
          }
        },
        {
          field: "ImageUrl",
          headerName: "Image",
          width: 80,
          renderCell: (params) => {
            return (
              <div className="cellWithImg">
                <img className="cellImg" src={axios.defaults.baseURL + '/' + params.row.ImageUrl} alt="avatar" />
              </div>
            );
          },
        },
        {
          field: "ModifiedBy",
          headerName: "Modified By",
          width: 120,
        },
        {
          field: "ModifiedOn",
          headerName: "Modified On",
          width: 150,
          renderCell: (params)=>{
            return(
              params.row.ModifiedOn &&
              <span>{format(new Date(params.row.ModifiedOn), 'DD/MM/YYYY HH:mm')}</span>
            );
          }
        }
    ],
    modulename: "Behavioral Clusters"
  };

  const handleOnCellClick = (params) => {
    setEditorState({ open: true, data: params.row});
  };

  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar title={model.modulename}/>
        <ErrorMessages message={errors}/>
        {
          editorState.open == true ? 
          <BehaviourClusterEditor data={editorState} setEditorState={setEditorState} setPageState={setPageState} setErrors={setErrors} /> : 
          <DataTable  {...model} rows={pageData.data}  />
        }
      </div>
    </div>
  )
}

export default BehavioralClusters